module.exports = __webpack_public_path__ + "media/assets/images/events/20210610_offcar/mkithp_backstage-e589bd8f0ed8f9ea33741a8d63158c97.jpg";